import * as Sentry from '@sentry/react'

let sentryInitialized = false

export function initSentry() {
  if (typeof window === 'undefined') return

  const dsn = (import.meta as any).env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) {
    return
  }

  if (sentryInitialized) {
    return
  }

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: (import.meta as any).env.PROD ? 0.1 : 1.0,
    environment: (import.meta as any).env.MODE,
  })

  sentryInitialized = true
}
